import _extends from 'babel-runtime/helpers/extends';
import RcCalendar from 'rc-calendar';
import MonthCalendar from 'rc-calendar/es/MonthCalendar';
import createPicker from './createPicker';
import wrapPicker from './wrapPicker';
import RangePicker from './RangePicker';
import WeekPicker from './WeekPicker';
var DatePicker = wrapPicker(createPicker(RcCalendar));
var MonthPicker = wrapPicker(createPicker(MonthCalendar), 'YYYY-MM');
_extends(DatePicker, {
    RangePicker: wrapPicker(RangePicker),
    MonthPicker: MonthPicker,
    WeekPicker: wrapPicker(WeekPicker, 'gggg-wo')
});
export default DatePicker;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/date-picker/index.js
// module id = 586
// module chunks = 0